import client from './client';
import { IUserLog, getRequestData, formatUserData, IBookLog } from './index';

export default (
    cid: string,
    user: IUserLog,
    book: Omit<IBookLog, 'status'>
) => {
    client.info('link account click', {
        cid,
        context: 'BetPlacePage#onLoginFormClick',
        book,
        ...formatUserData(user),
        ...getRequestData(),
    });
};
